import BalloonEditor from "@ckeditor/ckeditor5-build-balloon";
import { useStore } from 'vuex'
import { BASE_URL } from '@/network/v2'

export function useCkeditor() {
  const store = useStore()
  
  class MyUploadAdapter {
    constructor(loader, token) {
      this.loader = loader;
      this.token = token
    }

    upload() {
      return this.loader.file
        .then(file => new Promise((resolve, reject) => {
          this._initRequest(file);
          this._initListeners(resolve, reject, file);
          this._sendRequest(file);
        }));
    }

    // Aborts the upload process.
    abort() {
      if (this.xhr) {
        this.xhr.abort();
      }
    }

    _initRequest() {
      const xhr = this.xhr = new XMLHttpRequest();

      xhr.open('POST', `${BASE_URL}ckeditor-custom/upload/`, true);
      xhr.responseType = 'json';
      xhr.setRequestHeader('Authorization', `Bearer  ${this.token}`)
    }



    _initListeners(resolve, reject, file) {
      const xhr = this.xhr;
      const loader = this.loader;
      const genericErrorText = `Couldn't upload file: ${file.name}.`;

      xhr.addEventListener('error', () => reject(genericErrorText));
      xhr.addEventListener('abort', () => reject());
      xhr.addEventListener('load', () => {
        const response = xhr.response;

        if (!response || response.error) {
          // console.log(response.error)
          // console.log(response)
          return reject(response && response.error ? response.error.message : genericErrorText);
        }

        // console.log(response.url)
        resolve({
          default: response.url
        });
      });

      // Upload progress when it is supported. The file loader has the #uploadTotal and #uploaded
      // properties which are used e.g. to display the upload progress bar in the editor
      // user interface.
      if (xhr.upload) {
        xhr.upload.addEventListener('progress', evt => {
          if (evt.lengthComputable) {
            loader.uploadTotal = evt.total;
            loader.uploaded = evt.loaded;
          }
        });
      }
    }

    // Prepares the data and sends the request.
    _sendRequest(file) {
      // Prepare the form data.
      const data = new FormData();

      // data.append('upload', file);
      data.append('upload', file);

      // Important note: This is the right place to implement security mechanisms
      // like authentication and CSRF protection. For instance, you can use
      // XMLHttpRequest.setRequestHeader() to set the request headers containing
      // the CSRF token generated earlier by your application.

      // Send the request.
      this.xhr.send(data);
    }
  }

  // ...

  function MyCustomUploadAdapterPlugin(editor) {
    editor.plugins.get('FileRepository').createUploadAdapter = (loader) => {
      // Configure the URL to the upload script in your back-end here!
      return new MyUploadAdapter(loader, store.getters.access);
    };
    // console.log(editor.plugins)
    // console.log(editor.plugins.get('CKFinder'))
  }

  return {
    editor: BalloonEditor,
    editorConfig: {
      extraPlugins: [MyCustomUploadAdapterPlugin],
      // ckfinder: {
      //   uploadUrl: 'https://192.168.0.39:8001/media/uploads',
      //   filebrowserBrowseUrl: 'https://192.168.0.39:8001/ckeditor-custom/browse/',
      //   filebrowserImageBrowseUrl: 'https://tiffest.uz/ckeditor/browse/?CKEditor=id_description_ru&CKEditorFuncNum=1&langCode=en',
      //   filebrowserUploadUrl: 'https://zamon.al-electronics.uz/ckeditor/upload/&responseType=json',
      //   filebrowserImageUploadUrl: 'https://zamon.al-electronics.uz/ckeditor/upload/&responseType=json',
      // },
      toolbar: [
        'heading', '|',
        'bold', 'italic', '|',
        'link', '|',
        'outdent', 'indent', '|',
        'bulletedList', 'numberedList', '|',
        'insertTable', '|',
        'ImageUpload', 'ckfinder', 'mediaEmbed', 'blockQuote', '|',
        'mediaEmbed', 'blockQuote', '|',
        'undo', 'redo',]
    }
  }
}
